(ns frontend.view.components.timeline.entry.utils
  (:require [clojure.string :as string]
            [common.localization :as loc]
            [common.entity :as zap-entity]
            [frontend.zap-time :as zap-time]
            [frontend.state.current-session :as session]))

(defn str-tags [items]
  (string/join ", " items))

;; tag update
(defn tags [{add :add remove :remove}]
  (if remove
    (loc/tr :removed [(str-tags remove)])
    (str-tags add)))

(defn oppo-named-title-generator [entry]
  (let [op (-> entry :audit/op)
        name (->> entry
                  :audit/target
                  (get @session/entities)
                  :oppo/name)]
    (loc/tr op [name])))

(defn arrow-message [left right]
  [:div.timeline-arrow-line
   left
   [:i.fal.fa-arrow-right]
   (try
     (str (. right toNumber 10)) ;; hack to print goog.math.Long properly
     (catch js/Object o
       right))])

(defn person-timeline-title-generator [person entry]
  (let [op :op.person/update
        name (str (:person/first-name person) " " (:person/last-name person))]
    (loc/tr op [name])))

(defn person-timeline-update [target key val info]
  (let [target-type (:entity/type target)
        company? (= target-type :entity.type/company)
        deal? (= target-type :entity.type/oppo)
        attribute (string/lower-case (loc/tr key))
        add (or (:set val) (:add val))
        remove (or (:unset val) (:remove val))]
    (cond
      (and add company?) (loc/tr :person-added-to-company [(:asset/name target) attribute])
      (and add deal?) (loc/tr :person-added-to-deal [(:oppo/name target) attribute])
      (and remove company?) (loc/tr :person-removed-from-company [(:asset/name target) attribute])
      (and remove deal?) (loc/tr :person-removed-from-deal [(:oppo/name target) attribute]))))

(defn date-field-update [key val]
  (let [dt (cond (number? val) (zap-time/long->formatted-date val)
                 :else val)]
    (arrow-message (loc/tr key) dt)))
